module.exports = __webpack_public_path__ + "img/fruit-lemons-350x184.0a14127c.jpg";